// Widget whatsapp
// Luca Siviero

(function () {
    const PHONE = "393513977003";
    const LINK = `https://wa.me/${PHONE}`;

    const eligibleCollectionId = 667245511004;
    const product = window.product || {};

    const isEligible = Array.isArray(product.collections) && product.collections.some((c) => c.id == eligibleCollectionId);

    function injectFloatingWidget() {
        if (document.querySelector("#wr-whatsapp-widget")) return;

        const btn = document.createElement("a");
        btn.id = "wr-whatsapp-widget";
        btn.href = LINK;
        btn.target = "_blank";
        btn.setAttribute("aria-label", "Scrivici su WhatsApp");

        btn.innerHTML = `
        <div style="
            position: fixed;
            bottom: 60px;
            right: 20px;
            background-color: #25d366;
            border-radius: 50%;
            width: 48px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            z-index: 9999;
            cursor: pointer;
            transition: transform 0.2s ease;
        ">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg">
                <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z">
                </path>
            </svg>
        </div>
        `;
        document.body.appendChild(btn);
    }

    function injectProductButton() {
        const interval = setInterval(() => {
            const productSection = document.querySelector(".single-product-details.w-100");
            if (!productSection) return;

            const allBtns = productSection.querySelectorAll("#customily-personalize-button, .customily-personalize-button");
            const customizeBtn = Array.from(allBtns).find((b) => b.offsetParent !== null);

            if (customizeBtn && !document.querySelector("#wr-whatsapp-product-link")) {
                clearInterval(interval);

                const link = document.createElement("a");
                link.id = "wr-whatsapp-product-link";
                link.href = LINK;
                link.target = "_blank";
                link.textContent = "Hai richieste particolari? Scrivici su WhatsApp!";

                link.style.cssText = `
                    display: block;
                    margin-top: 16px;
                    margin-bottom: 16px;
                    text-decoration: underline !important;
                    color: #111 !important;
                    font-size: 14px;
                    font-family: Helvetica, Arial, sans-serif;
                    text-align: left;
                    cursor: pointer;
                `;

                customizeBtn.insertAdjacentElement("afterend", link);
            }
        }, 300);
    }


    function injectInCustomilyModalMobile() {
        const interval = setInterval(() => {
            const modal = document.querySelector(".csh-product-customizer-modal");
            if (!modal || modal.style.display === "none") return;

            const target = modal.querySelector(".csh-product-customizer-modal__options-wrapper");
            if (!target) return;
            if (modal.querySelector("#wr-whatsapp-modal-link-mobile")) return;

            const link = document.createElement("a");
            link.id = "wr-whatsapp-modal-link-mobile";
            link.href = LINK;
            link.target = "_blank";
            link.textContent = "Hai domande? Scrivici su WhatsApp";

            Object.assign(link.style, {
                width: "100%",
                display: "block",
                marginBottom: "14px",
                textDecoration: "underline",
                color: "#111",
                fontSize: "15px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: "500",
                textAlign: "center",
                cursor: "pointer",
            });

            target.parentElement.insertBefore(link, target);
        }, 400);
    }

    function injectInCustomilyModalDesktop() {
        const interval = setInterval(() => {
            const modal = document.querySelector(".customily-modal-container");
            if (!modal || modal.style.display === "none") return;

            const firstOption = modal.querySelector(".customily_option");
            if (!firstOption) return;
            if (modal.querySelector("#wr-whatsapp-modal-link-desktop")) return;

            const link = document.createElement("a");
            link.id = "wr-whatsapp-modal-link-desktop";
            link.href = LINK;
            link.target = "_blank";
            link.textContent = "Hai domande? Scrivici su WhatsApp";

            Object.assign(link.style, {
                display: "block",
                marginBottom: "14px",
                textDecoration: "underline",
                color: "#111",
                fontSize: "15px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: "500",
                textAlign: "center",
                cursor: "pointer",
            });

            // Inserisci PRIMA della prima opzione del modal
            firstOption.parentElement.insertBefore(link, firstOption);
        }, 400);
    }

    function init() {
        injectFloatingWidget();
        injectProductButton();
    }

    if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(init, 800);
    } else {
        document.addEventListener("DOMContentLoaded", () => setTimeout(init, 800));
    }
})();